import { useState, useEffect } from 'react';

interface TocItem {
  id: string;
  label: string;
}

const tocItems: TocItem[] = [
  { id: 'intro', label: 'ご活用いただくために' },
  { id: 'registration', label: '登録商標について' },
  { id: 'scope', label: '商標権の範囲' },
  { id: 'usage-examples', label: 'ライセンスが必要な利用例' },
  { id: 'license', label: '公式施設ライセンス' },
  { id: 'current-users', label: '現在利用中の施設様へ' },
  { id: 'government', label: '自治体・官公庁の皆様へ' },
  { id: 'cases', label: '使用許諾の事例' },
  { id: 'faq', label: 'よくあるご質問' },
  { id: 'closing', label: 'お問い合わせ' },
];

export default function TableOfContents() {
  const [activeId, setActiveId] = useState<string>('');

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActiveId(entry.target.id);
          }
        });
      },
      { rootMargin: '-20% 0px -60% 0px', threshold: 0 }
    );

    tocItems.forEach((item) => {
      const el = document.getElementById(item.id);
      if (el) observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, id: string) => {
    e.preventDefault();
    const el = document.getElementById(id);
    if (el) {
      const navHeight = 80;
      const top = el.getBoundingClientRect().top + window.scrollY - navHeight;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };

  return (
    <nav className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6 md:p-8">
      <h2 className="text-lg font-bold text-slate-800 mb-5 flex items-center gap-2">
        <i className="ri-list-check text-orange-500"></i>
        このページの内容
      </h2>
      <ul className="grid grid-cols-1 sm:grid-cols-2 gap-2">
        {tocItems.map((item) => (
          <li key={item.id}>
            <a
              href={`#${item.id}`}
              onClick={(e) => handleClick(e, item.id)}
              className={`flex items-center gap-2 px-3 py-2 rounded-lg text-sm transition-colors cursor-pointer ${
                activeId === item.id
                  ? 'bg-orange-50 text-orange-700 font-semibold'
                  : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
              }`}
            >
              <span
                className={`w-1.5 h-1.5 rounded-full flex-shrink-0 ${
                  activeId === item.id ? 'bg-orange-500' : 'bg-gray-300'
                }`}
              />
              {item.label}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
}